module.exports = __webpack_public_path__ + "static/media/vday1.0ffefa8f.jpeg";